import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Search as SearchIcon } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Box, Button, Card,
    CardContent, TextField, InputAdornment,
    Grid, Select, MenuItem,
    InputLabel, FormControl
} from '@mui/material';
import { RequestUtils } from 'modules/api';

const useStyles = makeStyles((theme) => ({
    root: {},
    exportButton: {
        marginLeft: '20px !important'
    },
    selectWidth: {
        width: '100%'
    }
}));

const ExportToCsv = (event) => {

    RequestUtils.getExportUsers().then((res) => {
        
        window.open('http://parardefumarfumando.app.br/export/output.csv', '_blank', 'noopener,noreferrer');

    }).catch((e) => {
      
    });

    
};

function Toolbar({
    className,
    inputValue,
    pagedObject,
    onPressButton,
    handleChange,
    inputLabel = '',
    ...rest
}) {
    const classes = useStyles();
    return (
        <div className={clsx(classes.root, className)} {...rest}>
            <Box display="flex" justifyContent="flex-end">
                <Button
                    color="primary"
                    variant="contained"
                    component={RouterLink}
                    to={"/usuarios/cadastrar"}
                >
                    Adicionar usuário
                </Button>
                <Button
                    color="primary"
                    className={classes.exportButton}
                    variant="contained"
                    onClick={ExportToCsv}
                >
                    Exportar usuários
                </Button>
            </Box>
            <Box mt={3}>
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item md={6} xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item md={12} xs={12}>
                                        <TextField
                                            fullWidth
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <LoadingButton variant="contained" onClick={onPressButton}>
                                                            <SearchIcon fontSize="small" color="white" />
                                                        </LoadingButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            placeholder={"Buscar por usuário"}
                                            variant="outlined"
                                            label={inputLabel}
                                            value={inputValue}
                                            onChange={(e) => handleChange("searchTerm", e.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item md={2} xs={6}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="select-userPlan-label">Plano do usuário</InputLabel>
                                    <Select
                                        labelId="select-userPlan-label"
                                        id="select-userPlan"
                                        value={pagedObject.userPlan}
                                        label="Plano do usuário"
                                        onChange={(e) => handleChange("userPlan", e.target.value)}
                                        fullWidth
                                    >
                                        <MenuItem value={0}>Grátis</MenuItem>
                                        <MenuItem value={1}>Premium</MenuItem>
                                        <MenuItem value={2}>Todos</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item md={2} xs={6}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="select-userType-label">Tipo do usuário</InputLabel>
                                    <Select
                                        labelId="select-userType-label"
                                        id="select-userType"
                                        value={pagedObject.userType}
                                        label="Tipo do usuário"
                                        onChange={(e) => handleChange("userType", e.target.value)}
                                        fullWidth
                                    >
                                        <MenuItem value={0}>Comum</MenuItem>
                                        <MenuItem value={1}>Administrador</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item md={2} xs={6}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="select-userActive-label">Status do usuário</InputLabel>
                                    <Select
                                        labelId="select-userActive-label"
                                        id="select-userActive"
                                        value={pagedObject.userActive}
                                        label="Status do usuário"
                                        onChange={(e) => handleChange("userActive", e.target.value)}
                                        fullWidth
                                    >
                                        <MenuItem value={true}>Ativo</MenuItem>
                                        <MenuItem value={false}>Inativo</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
};

Toolbar.propTypes = {
    className: PropTypes.string,
    inputValue: PropTypes.string.isRequired,
    pagedObject: PropTypes.object.isRequired,
    onPressButton: PropTypes.func.isRequired,
    inputLabel: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
};

export default Toolbar;